var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentType)?_c(_vm.componentType,{tag:"component",class:("layout-element--" + (_vm.element.type)),attrs:{"element":_vm.element,"ratio":_vm.ratio,"is-summary-view":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }